import type { Operation } from "starfx";
import { call, race, sleep } from "starfx";

export function callWithTimeout<T>(operation: Operation<T>, timeout = 10000) {
  return race([
    call(operation),
    call(function* () {
      yield* sleep(timeout);
      throw new Error("operation timed out");
    }),
  ]);
}
